import React, { StrictMode } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { loadableReady } from '@loadable/component';
import { BrowserRouter } from 'react-router-dom';

import pkg from '../package.json';
import Root from './root.component';

const rootId = `application:${pkg.name}`;

loadableReady(() => {
  let domElement = document.getElementById(rootId);

  if (!document.body.contains(domElement)) {
    domElement = document.createElement('section');
    domElement.id = rootId;
    document.body.appendChild(domElement);
  }

  if (domElement && domElement.hasChildNodes()) {
    hydrateRoot(
      domElement,
      <StrictMode>
        <BrowserRouter>
          <Root />
        </BrowserRouter>
        ,
      </StrictMode>,
    );
  } else {
    const root = createRoot(domElement as HTMLElement);
    root.render(
      <StrictMode>
        <BrowserRouter>
          <Root />
        </BrowserRouter>
      </StrictMode>,
    );
  }
});
